/***
 * @Author: ZhaoG
 * @Date: 2025-12-02 16:58:27
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-03-06 15:50:23
 * @FilePath: \sra-fe\src\setting\setting.js
 * @Description:
 */
// import { isDevOrLocalhost } from "@/basa/utils";

/***
 * 全局判断配置中心
 * ***/

// const CONFIG = {
//   parentId: isDevOrLocalhost() ? "100001" : "100002", // 配置组织根节点id
//   duration: 3000, //后端返回错误提示框自动关闭事件 0为不自动关闭
//   requestDuration: 1000, //拒绝前端连续请求 间隔为1s
//   axiosTimeOut: 600000, //axios超时时间
//   isMenuMock: false //是否适用mock菜单
// };

// export default CONFIG;
export let commonTableWidth = Object.freeze({
  serialNoWidth: 51, //序号
  checkboxWidth: 55, //复选框
  telWidth: 110, //手机号
  dateYMWidth: 70, // 年月 时间宽度 【2022-11】
  dateWidth: 110, // 年月日时间宽度
  dateTimeWidth: 170, // 年月日时分秒时间宽度
  unitName: 220, // 单位
  joinTrainNumStr: 160, // 参与评标专家培训期数
  expertFieldStr: 80, // 专家擅长领域【 5个汉字】
  unitDepartment: 160, // 部门
  supplierName: 350, // 供应商名称
  termOfValidity: 180, // 有效期 【2021-11-30至2021-11-30】
  approvalStatus: 70, // 审批状态
  area: 200
});
export let pageTableWidth = Object.freeze({
  dateWidth: 150, // 年月日时间宽度
  dateTimeWidth: 170 // 年月日时分秒时间宽度
});
export let assessTaskWidth = Object.freeze({
  taskCode: 150, // 考核编号
  taskName: 150, // 考核名称
  taskTime: 300 // 考核日期
});
export let opCloWidth = Object.freeze({
  /**设备物资编码Begin**/
  codeplatformApplyLists: 150, // 设备物资编码申请
  codeplatformApproveLists: 50, // 设备物资编码审批
  codeplatformTakeffectsAlllist: 50, // 设备物资类别维护
  codeplatformComtakeeffectLists: 50, // 常用编码类型维护
  /**设备物资编码End**/
  /**采购计划Begin**/
  procurementPlanningList: 120,
  purchasePlanAdjustList: 220,
  approvalPurchasingPlanList: 50,
  /**采购计划End**/
  /**采购任务Begin**/
  taskPreparation: 120,
  taskPreparationApprove: 50,
  preparationPlanCreate: 110,
  /**采购任务End**/
  /**采购方案Begin**/
  purchaseschemeCompileList: 160, // 方案编制列表操作宽度
  approvalQueryList: 50, // 方案审批列表操作宽度
  purchaseSchemeConfirmList: 50, // 方案确认列表操作宽度
  /**采购方案End**/
  /**专家Begin**/
  expertManageInput: 100,
  inputApproveList: 50,
  expertManageChangeList: 150,
  expertManageApproveList: 50,
  expertManageRecomList: 120,
  expertManageReApproveList: 50,
  expertSearchList: 50,
  expertStateSearchList: 50,
  expertUnitAdjustmentList: 50,
  expertManageEnable: 50,
  subExpertArchivesManageOperWidth: 270,
  /**专家End**/
  /**供应商Begin**/
  supregreviewList: 50,
  supchangereviewList: 50,
  supmanage: 50,
  suprecommendList: 50,
  suprecommendreviewList: 50,
  cooperationIntentionList: 50,
  supPasswordResetList: 70,
  supPasswordLoginID: 100,
  supSendBackList: 50,
  supHierarchyUpList: 50,
  supHierarchyDownList: 50,
  supMaintenanceList: 200,
  suptypeQualName: 100,
  productList: 200,
  supRegNum: 170,
  /**供应商End**/
  /**框架协议Begin**/
  agreementMaintainList: 200, //  框架协议维护列表操作宽度
  agreementMaintainChangeList: 210,
  frameAgrApprovalList: 50,
  frameAgrTerApprovalList: 50,
  materialAgrGenContractList: 70,
  equipmentAgrGenContractList: 70,
  /**框架协议End**/
  /**采购寻源Begin**/
  sourcingManageList: 50
  /**采购寻源End**/
});
// 采购方案表格宽度统一配置
export let schemeColWidth = Object.freeze({
  schemeCode: 200, //方案编码
  schemeName: 150 // 方案名称
});
export let planColWidth = Object.freeze({
  planCode: 130, //计划编码
  planName: 130 // 计划名称
});
//设备物资表格列宽度
export let codePlatColWidth = Object.freeze({
  matcodeNum: 110, //设备物资编码
  matcodeName: 300, // 设备物资名称
  matcodeNum2: 120
});
//框架协议表格列宽度
export let agrColWidth = Object.freeze({
  protocolCode: 380, //协议编号
  protocolName: 150 //协议名称
});
//任务表格列宽度
export let taskColWidth = Object.freeze({
  taskCode: 130, //任务编号
  taskName: 130 //任务名称
});
// 详情页样式控制器
export let detailDomStyle = Object.freeze({
  style01: "detail-box ccui-clearfix", // 有右侧 有底部
  style02: "detail-box ccui-clearfix", // 有右侧 有底部
  // style02: "detail-box2 ccui-clearfix", // 有右侧 无底部
  style03: "detail-box3 ccui-clearfix", // 没有右侧 有底部
  style04: "detail-box3 ccui-clearfix" // 没有右侧 无底部
});
export let operState = Object.freeze({
  1: "approving",
  2: "approvaled"
});
export let schemeOperState = Object.freeze({
  1: "approving",
  2: "sendback",
  3: "approvaled",
  4: ""
});
export let taskOperState = Object.freeze({
  1: "approving",
  2: "sendback",
  3: "approvaled",
  4: ""
});
export let agrApprovingTypeNew = Object.freeze({
  1: "", //提交(申请人)
  3: "approvaled", // 同意
  4: "sendback", // 退回
  // 4: "sendback", // 不同意
  5: "approving", // 协办
  6: "approving", // 转审
  7: "sendback", // 业务端撤回
  8: "", // 编辑
  9: "sendback", // 退回申请人
  10: "", // 业务单据删除
  2: "approving" // 审批中
});
export let agrApprovingType = Object.freeze({
  1: "", //提交(申请人)
  2: "approvaled", // 同意
  3: "sendback", // 退回
  4: "sendback", // 不同意
  5: "approving", // 协办
  6: "approving", // 转审
  7: "sendback", // 业务端撤回
  8: "", // 编辑
  9: "sendback", // 退回申请人
  10: "", // 业务单据删除
  11: "approving" // 审批中
});
export let agrStopApprovingType = Object.freeze({
  1: "approving",
  2: "terminated", // 已终止
  8: "" // 编辑
});
export let commonApprovingType = Object.freeze({
  1: "", //提交(申请人)
  2: "approvaled", // 同意
  3: "sendback", // 退回
  4: "sendback", // 不同意
  5: "approving", // 协办
  6: "approving", // 转审
  7: "sendback", // 业务端撤回
  8: "", // 编辑
  9: "sendback", // 退回申请人
  10: "", // 业务单据删除
  11: "approving" // 审批中
});
// 分包资料编制 和 采购方案 下载模板的uploadId
export let uploadIds = Object.freeze({
  dev01: "10005489548",
  test01: "10001027745",
  uat01: "10005140093"
});


//设备物资编码弹窗表格
export let materialCodeDialogWidth = Object.freeze({
  selectionA: 35, //选择样式A
  selectionB: 45, //选择样式B
  serialNoWidth: 45, //序号
  matcodeNum: 110, //设备物资编码最小宽度
  matcodeName: 250, // 设备物资名称
  matcodeName1: 240, // 设备物资名称
  classCodeNum: 100, // 分类编码
  minClassName: 150, //分类名称
  unitName: 80, //计量单位
  matcateryCodeBig: 100, // 大类编码
  matcateryNameBig: 150, // 大类名称
  matcateryCodeMid: 100, // 中类编码
  matcateryNameMid: 150, // 中类名称
  matcateryCodeSmall: 100, // 小类编码
  matcateryNameSmall: 150 // 小类名称
});
